import { Work } from '@/model/master-data/Work'

export class FreeShiftWork {
  public constructor (
    readonly shiftId: number | undefined,
    readonly planningGroupId: number | undefined,
    readonly qcqId: number | undefined,
    readonly work: number,
    public workCode: string,
    public planningGroup: number | undefined,
    readonly alreadyInsert: string | null,
    readonly offset: string,
    public workItem: Work | undefined
  ) {}

  get displayLabel ():string {
    if(this.workItem) {
      return `${this.workItem.code} - ${this.workItem.getDescriptionLabel}`
    } else {
      return this.workCode
    }
  }
}
